import '../styles/stickynoteform.css';
import React, { useRef, useState } from 'react';
import Draggable from 'react-draggable';
import emailjs from 'emailjs-com';

const StickyNoteForm = ({ emailLabel, messageLabel, buttonText }) => {
    const nodeRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [formData, setFormData] = useState({ email: '', message: '' });
    const [successMessage, setSuccessMessage] = useState('');


    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    const preventClose = (e) => {
        e.stopPropagation(); // Prevent closing when interacting with the form
    };
    const textColor = "#000000"

    const handleChange = (e) => {
        setFormData({
            ...formData, [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        emailjs.send(
            process.env.REACT_APP_EMAILJS_SERVICE_ID, 
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
            {
                user_email: formData.email,
                user_message: formData.message,
            },
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        )
        .then((response) => {
            console.log("Email sent successfully!", response);
            setSuccessMessage("Message sent successfully! ✅");
            setFormData({ email: '', message: '' });
            setTimeout(() => setSuccessMessage(''), 5000);
        })
        .catch((error) => {
            console.error("Email sending failed:", error);
            setSuccessMessage("Failed to send message. ❌");
            setTimeout(() => setSuccessMessage(''), 5000);
        });
    };

    return (
        <Draggable nodeRef={nodeRef} defaultPosition={{ x: 40, y: 350 }} handle=".sticky-note" cancel="input, textarea, button">
            <div className="sticky-note" ref={nodeRef} onClick={toggleOpen} onTouchStart={toggleOpen} role="button" tabIndex={0} style={{ color: textColor}}>
                <p>Drag me or click me !</p>
                <p>Leave a quick message:</p>
                {isOpen && (
                    <form id="feedbackForm" className="feedback-form" onClick={preventClose} onMouseDown={preventClose} onTouchStart={preventClose} onSubmit={handleSubmit}>
                        <label htmlFor="userEmail">{emailLabel}</label>
                        <input type="email" id="userEmail" name="email" value={formData.email} onChange={handleChange} required />

                        <label htmlFor="userMessage">{messageLabel}</label>
                        <textarea id="userMessage" name="message" value={formData.message} onChange={handleChange} required></textarea>

                        <button type="submit">{buttonText}</button>
                        {successMessage && <p className="success-message">{successMessage}</p>}
                    </form>
                )}
            </div>
        </Draggable>
    );
};

export default StickyNoteForm;
